import jwt from "jsonwebtoken";
import { stringify } from "query-string";
import { checkResponse } from "../utils/checkResponse";
import {
  APIKey,
  Authorization,
  Channel,
  DomainAPI,
  SecretApiKey,
  SecretApiKeyExpires,
  _pick,
} from "../utils/setting";

const order = {
  state: {
    listOrders: [],
    listBranchOrders: [],
    selectedBranch: "", // is string
    statistics: [],
    detailOrder: {},
    oldestDate: new Date(),
    lastestDate: new Date(),
    total: 0,
    count: 0,
    reportOrderCustomer: {},
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
    changeSelectedBranch(state, payload) {
      state.selectedBranch = payload;
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    getListOrdersForBranch(payload, rootState) {
      const _this = this;
      let myHeaders = new Headers();
      let key = jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(
        DomainAPI + Channel + "/api/secure/orders/getListOrdersForBranch",
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(payload),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1)
            _this.setState({
              listOrders: result.data.list,
              total: result.data.total,
              count: result.data.count,
            });
          else _this.setState({ listOrders: [], total: 0 });
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async updateNoteOrder(payload, rootState) {
      const _this = this;
      let myHeaders = new Headers();
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(DomainAPI + Channel + "/api/secure/orders/updateNoteOrder", {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({
          note: payload.note,
          orderCode: payload.orderCode,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1)
            _this.getListOrdersForBranch(rootState.order.selectedBranch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async getListBranch(payload, rootState) {
      const _this = this;
      let myHeaders = new Headers();
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(
        DomainAPI + Channel + "/api/secure/serviceBranches/getListBranch",
        {
          method: "POST",
          headers: myHeaders,
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) {
            _this.setState({ listBranchOrders: result.data });
          }
          return result.code;
        })
        .catch((error) => {
          return false;
        });
    },
    async deleteOrders(payload, rootState) {
      let myHeaders = new Headers();
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(DomainAPI + Channel + "/api/secure/orders/deleteOrders", {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({
          ordersCodeArray: payload,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    // async searchOrder(payload, rootState) {
    //     if (!payload) {
    //         // this.getListOrdersForBranch(rootState.order.selectedBranch)
    //     }
    //     else {
    //         const _this = this;
    //         let myHeaders = new Headers();
    //         let key = await jwt.sign({ data: Math.random() }, SecretApiKey, { expiresIn: SecretApiKeyExpires });
    //         myHeaders.append('Content-Type', 'application/json');
    //         myHeaders.append(APIKey, key);
    //         myHeaders.append(Authorization, rootState.user.token);
    //         return fetch(DomainAPI + Channel + "/api/secure/orders/searchOrder", {
    //             method: 'POST',
    //             headers: myHeaders,
    //             body: JSON.stringify({
    //                 orderCode: Number(payload),
    //                 branchCode: rootState.order.selectedBranch,
    //             }),
    //         }).then(res => res.json())
    //             .then((result) => {
    //                 checkResponse(result, dispatch)
    //                 if (result.code === 1) this.setState({listOrders: result.data})
    //                 return result.code
    //             }).catch(error => {return false})
    //     }

    // },
    async getLatestDate(payload = { query: {}, sort: "createdAt" }, rootState) {
      const _this = this;
      let url = DomainAPI + Channel + "/api/secure/orders/latestDate";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({ query: payload.query, sort: payload.sort }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) _this.setState({ lastestDate: result.data });
          return result.code;
        })
        .catch((error) => {
          return false;
        });
    },
    async getOldestDate(payload = { query: {}, sort: "createdAt" }, rootState) {
      const _this = this;
      let token = rootState.user.token;
      let url = DomainAPI + Channel + "/api/secure/orders/oldestDate";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({ query: payload.query, sort: payload.sort }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) _this.setState({ oldestDate: result.data });
          return result.code;
        })
        .catch((error) => {
          return false;
        });
    },
    async reportOrderCustomer(payload = {}, rootState) {
      const _this = this;
      let token = rootState.user.token;
      let url = DomainAPI + Channel + "/api/secure/orders/reportOrderCustomer";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1)
            _this.setState({ reportOrderCustomer: result.data });
          else _this.setState({ reportOrderCustomer: {} });
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async statisticsOrder(payload = {}, rootState) {
      const _this = this;
      let myHeaders = new Headers();
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(DomainAPI + Channel + "/api/secure/orders/statisticsOrder", {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) _this.setState({ statistics: result.data });
          else _this.setState({ statistics: [] });
          return result;
        })
        .catch((error) => {
          this.setState({ statistics: [] });
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async findByCode(payload = {}, rootState) {
      const _this = this;
      let myHeaders = new Headers();
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(
        `${DomainAPI}${Channel}/api/secure/orders/findByCode?${stringify(
          _pick(payload, ["orderCode"])
        )}`,
        {
          method: "GET",
          headers: myHeaders,
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) _this.setState({ detailOrder: result.data });
          else _this.setState({ detailOrder: {} });
          return result;
        })
        .catch((error) => {
          this.setState({ statistics: [] });
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async handleAddPayment(payload = {}, rootState) {
      let token = rootState.user.token;
      let url = DomainAPI + Channel + "/api/secure/orders/handleAddPayment";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async updatePaymentOrder(payload = {}, rootState) {
      let token = rootState.user.token;
      let url = DomainAPI + Channel + "/api/secure/orders/updatePaymentOrder";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async deletePaymentOrder(payload = {}, rootState) {
      let token = rootState.user.token;
      let url = DomainAPI + Channel + "/api/secure/orders/deletePaymentOrder";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
  }),
};

export default order;
